__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/af73eb211e00f4f83e194ebfe68784d94effb06381e41f4a22e18296/";